import { defineMessages } from 'react-intl';
import type { ProductCategoryEnum } from '@foundershub/api-client';

export const productCategoryLabels = defineMessages<ProductCategoryEnum>({
  '3d-modeling-rendering-software': {
    defaultMessage: '3D Modeling & Rendering Software',
    description: 'product category label',
  },
  '5g-home-internet': {
    defaultMessage: '5G Home Internet',
    description: 'product category label',
  },
  'adsl-internet': {
    defaultMessage: 'ADSL Internet',
    description: 'product category label',
  },
  'api-management-software': {
    defaultMessage: 'API Management Software',
    description: 'product category label',
  },
  'accounts-payable-ap-automation-software': {
    defaultMessage: 'Accounts Payable (AP) Automation Software',
    description: 'product category label',
  },
  'advanced-distribution-management-systems': {
    defaultMessage: 'Advanced Distribution Management Systems',
    description: 'product category label',
  },
  'anti-money-laundering-aml-software': {
    defaultMessage: 'Anti-Money Laundering (AML) Software',
    description: 'product category label',
  },
  'application-performance-monitoring-apm-software': {
    defaultMessage: 'Application Performance Monitoring (APM) Software',
    description: 'product category label',
  },
  'architectural-cad-software': {
    defaultMessage: 'Architectural CAD Software',
    description: 'product category label',
  },
  'artificial-intelligence': {
    defaultMessage: 'Artificial Intelligence',
    description: 'product category label',
  },
  'asset-tracking-software': {
    defaultMessage: 'Asset Tracking Software',
    description: 'product category label',
  },
  'audit-management-software': {
    defaultMessage: 'Audit Management Software',
    description: 'product category label',
  },
  'auto-dealer-software': {
    defaultMessage: 'Auto Dealer Software',
    description: 'product category label',
  },
  'auto-repair-software': {
    defaultMessage: 'Auto Repair Software',
    description: 'product category label',
  },
  'automated-testing-software': {
    defaultMessage: 'Automated Testing Software',
    description: 'product category label',
  },
  'automotive-marketing-software': {
    defaultMessage: 'Automotive Marketing Software',
    description: 'product category label',
  },
  'aviation-mro-software': {
    defaultMessage: 'Aviation MRO Software',
    description: 'product category label',
  },
  'big-data-analytics-software': {
    defaultMessage: 'Big Data Analytics Software',
    description: 'product category label',
  },
  'big-data-processing-distribution-software': {
    defaultMessage: 'Big Data Processing & Distribution Software',
    description: 'product category label',
  },
  'billing-invoicing-software': {
    defaultMessage: 'Billing & Invoicing Software',
    description: 'product category label',
  },
  'blockchain-platforms': {
    defaultMessage: 'Blockchain Platforms',
    description: 'product category label',
  },
  'building-information-modeling-bim-software': {
    defaultMessage: 'Building Information Modeling (BIM) Software',
    description: 'product category label',
  },
  'business-continuity-software': {
    defaultMessage: 'Business Continuity Software',
    description: 'product category label',
  },
  'business-intelligence-bi-software': {
    defaultMessage: 'Business Intelligence (BI) Software',
    description: 'product category label',
  },
  'business-management-software': {
    defaultMessage: 'Business Management Software',
    description: 'product category label',
  },
  'business-process-management-software': {
    defaultMessage: 'Business Process Management Software',
    description: 'product category label',
  },
  'calendar-software': {
    defaultMessage: 'Calendar Software',
    description: 'product category label',
  },
  'calibration-management-software': {
    defaultMessage: 'Calibration Management Software',
    description: 'product category label',
  },
  'call-center-software': {
    defaultMessage: 'Call Center Software',
    description: 'product category label',
  },
  'camp-management-software': {
    defaultMessage: 'Camp Management Software',
    description: 'product category label',
  },
  'car-rental-software': {
    defaultMessage: 'Car Rental Software',
    description: 'product category label',
  },
  'casino-management-systems': {
    defaultMessage: 'Casino Management Systems',
    description: 'product category label',
  },
  'chatbot-platforms-software': {
    defaultMessage: 'Chatbot Platforms Software',
    description: 'product category label',
  },
  'chemical-process-simulation-software': {
    defaultMessage: 'Chemical Process Simulation Software',
    description: 'product category label',
  },
  'childcare-software': {
    defaultMessage: 'Childcare Software',
    description: 'product category label',
  },
  'church-management-software': {
    defaultMessage: 'Church Management Software',
    description: 'product category label',
  },
  'citizen-engagement-software': {
    defaultMessage: 'Citizen Engagement Software',
    description: 'product category label',
  },
  'civil-engineering-design-software': {
    defaultMessage: 'Civil Engineering Design Software',
    description: 'product category label',
  },
  'classroom-management-software': {
    defaultMessage: 'Classroom Management Software',
    description: 'product category label',
  },
  'clinical-trial-management-systems': {
    defaultMessage: 'Clinical Trial Management Systems',
    description: 'product category label',
  },
  'cloud-content-collaboration-software': {
    defaultMessage: 'Cloud Content Collaboration Software',
    description: 'product category label',
  },
  'cloud-integration-software': {
    defaultMessage: 'Cloud Integration Software',
    description: 'product category label',
  },
  'cloud-migration-tools': {
    defaultMessage: 'Cloud Migration Tools',
    description: 'product category label',
  },
  'cloud-monitoring-tools': {
    defaultMessage: 'Cloud Monitoring Tools',
    description: 'product category label',
  },
  'coaching-software': {
    defaultMessage: 'Coaching Software',
    description: 'product category label',
  },
  'complaint-management-software': {
    defaultMessage: 'Complaint Management Software',
    description: 'product category label',
  },
  'computer-aided-design-cad-software': {
    defaultMessage: 'Computer-Aided Design (CAD) Software',
    description: 'product category label',
  },
  'computer-aided-engineering-cae-software': {
    defaultMessage: 'Computer-Aided Engineering (CAE) Software',
    description: 'product category label',
  },
  'computer-aided-manufacturing-cam-software': {
    defaultMessage: 'Computer-Aided Manufacturing (CAM) Software',
    description: 'product category label',
  },
  'computer-assisted-qualitative-data-analysis-software-caqdas': {
    defaultMessage: 'Computer-Assisted Qualitative Data Analysis Software (CAQDAS)',
    description: 'product category label',
  },
  'computerized-maintenance-management-systems-cmms': {
    defaultMessage: 'Computerized Maintenance Management Systems (CMMS)',
    description: 'product category label',
  },
  'configure-price-quote-cpq-software': {
    defaultMessage: 'Configure Price Quote (CPQ) Software',
    description: 'product category label',
  },
  'construction-accounting-software': {
    defaultMessage: 'Construction Accounting Software',
    description: 'product category label',
  },
  'construction-bid-management-software': {
    defaultMessage: 'Construction Bid Management Software',
    description: 'product category label',
  },
  'construction-estimating-software': {
    defaultMessage: 'Construction Estimating Software',
    description: 'product category label',
  },
  'construction-management-software': {
    defaultMessage: 'Construction Management Software',
    description: 'product category label',
  },
  'contact-tracing-software': {
    defaultMessage: 'Contact Tracing Software',
    description: 'product category label',
  },
  'contract-management-software': {
    defaultMessage: 'Contract Management Software',
    description: 'product category label',
  },
  'conversational-ai-software': {
    defaultMessage: 'Conversational AI Software',
    description: 'product category label',
  },
  'core-banking-systems': {
    defaultMessage: 'Core Banking Systems',
    description: 'product category label',
  },
  'corporate-learning-management-systems-lms': {
    defaultMessage: 'Corporate Learning Management Systems (LMS)',
    description: 'product category label',
  },
  'corporate-tax-software': {
    defaultMessage: 'Corporate Tax Software',
    description: 'product category label',
  },
  'courier-software': {
    defaultMessage: 'Courier Software',
    description: 'product category label',
  },
  'course-authoring-software': {
    defaultMessage: 'Course Authoring Software',
    description: 'product category label',
  },
  'court-management-software': {
    defaultMessage: 'Court Management Software',
    description: 'product category label',
  },
  'customer-communications-management-software': {
    defaultMessage: 'Customer Communications Management Software',
    description: 'product category label',
  },
  'customer-engagement-software': {
    defaultMessage: 'Customer Engagement Software',
    description: 'product category label',
  },
  'customer-experience-management-software': {
    defaultMessage: 'Customer Experience Management Software',
    description: 'product category label',
  },
  'customer-loyalty-software': {
    defaultMessage: 'Customer Loyalty Software',
    description: 'product category label',
  },
  'customer-relationship-management-crm-software': {
    defaultMessage: 'Customer Relationship Management (CRM) Software',
    description: 'product category label',
  },
  'data-extraction-software': {
    defaultMessage: 'Data Extraction Software',
    description: 'product category label',
  },
  'data-labeling-platforms': {
    defaultMessage: 'Data Labeling Platforms',
    description: 'product category label',
  },
  'data-management-platforms-dmp': {
    defaultMessage: 'Data Management Platforms (DMP)',
    description: 'product category label',
  },
  'data-mining-tools': {
    defaultMessage: 'Data Mining Tools',
    description: 'product category label',
  },
  'data-privacy-management-software': {
    defaultMessage: 'Data Privacy Management Software',
    description: 'product category label',
  },
  'data-quality-software': {
    defaultMessage: 'Data Quality Software',
    description: 'product category label',
  },
  'data-science-machine-learning-platforms': {
    defaultMessage: 'Data Science & Machine Learning Platforms',
    description: 'product category label',
  },
  'data-visualization-software': {
    defaultMessage: 'Data Visualization Software',
    description: 'product category label',
  },
  'data-centric-security-software': {
    defaultMessage: 'Data-Centric Security Software',
    description: 'product category label',
  },
  'database-monitoring-software': {
    defaultMessage: 'Database Monitoring Software',
    description: 'product category label',
  },
  'decision-support-software': {
    defaultMessage: 'Decision Support Software',
    description: 'product category label',
  },
  'deep-learning-software': {
    defaultMessage: 'Deep Learning Software',
    description: 'product category label',
  },
  'demand-planning-software': {
    defaultMessage: 'Demand Planning Software',
    description: 'product category label',
  },
  'dental-imagery-software': {
    defaultMessage: 'Dental Imagery Software',
    description: 'product category label',
  },
  'desktop-publishing-software': {
    defaultMessage: 'Desktop Publishing Software',
    description: 'product category label',
  },
  'devops-software': {
    defaultMessage: 'DevOps Software',
    description: 'product category label',
  },
  'digital-adoption-platforms': {
    defaultMessage: 'Digital Adoption Platforms',
    description: 'product category label',
  },
  'digital-asset-management-dam-software': {
    defaultMessage: 'Digital Asset Management (DAM) Software',
    description: 'product category label',
  },
  'digital-signage-software': {
    defaultMessage: 'Digital Signage Software',
    description: 'product category label',
  },
  'document-creation-software': {
    defaultMessage: 'Document Creation Software',
    description: 'product category label',
  },
  'document-management-software': {
    defaultMessage: 'Document Management Software',
    description: 'product category label',
  },
  'drone-management-software': {
    defaultMessage: 'Drone Management Software',
    description: 'product category label',
  },
  'dry-cleaning-software': {
    defaultMessage: 'Dry Cleaning Software',
    description: 'product category label',
  },
  'e-commerce-platforms': {
    defaultMessage: 'E-Commerce Platforms',
    description: 'product category label',
  },
  'e-prescribing-software': {
    defaultMessage: 'E-Prescribing Software',
    description: 'product category label',
  },
  'e-signature-software': {
    defaultMessage: 'E-Signature Software',
    description: 'product category label',
  },
  'ehs-management-software': {
    defaultMessage: 'EHS Management Software',
    description: 'product category label',
  },
  'ev-charging-management-software': {
    defaultMessage: 'EV Charging Management Software',
    description: 'product category label',
  },
  'education-erp-systems': {
    defaultMessage: 'Education ERP Systems',
    description: 'product category label',
  },
  'electrical-design-software': {
    defaultMessage: 'Electrical Design Software',
    description: 'product category label',
  },
  'electronic-data-capture-edc-software': {
    defaultMessage: 'Electronic Data Capture (EDC) Software',
    description: 'product category label',
  },
  'electronic-health-records-ehr-software': {
    defaultMessage: 'Electronic Health Records (EHR) Software',
    description: 'product category label',
  },
  'email-marketing-software': {
    defaultMessage: 'Email Marketing Software',
    description: 'product category label',
  },
  'email-security-software': {
    defaultMessage: 'Email Security Software',
    description: 'product category label',
  },
  'employee-engagement-software': {
    defaultMessage: 'Employee Engagement Software',
    description: 'product category label',
  },
  'employee-performance-management-software': {
    defaultMessage: 'Employee Performance Management Software',
    description: 'product category label',
  },
  'employee-scheduling-software': {
    defaultMessage: 'Employee Scheduling Software',
    description: 'product category label',
  },
  'energy-management-software': {
    defaultMessage: 'Energy Management Software',
    description: 'product category label',
  },
  'enterprise-accounting-software': {
    defaultMessage: 'Enterprise Accounting Software',
    description: 'product category label',
  },
  'enterprise-asset-management-eam-software': {
    defaultMessage: 'Enterprise Asset Management (EAM) Software',
    description: 'product category label',
  },
  'enterprise-cloud-platforms': {
    defaultMessage: 'Enterprise Cloud Platforms',
    description: 'product category label',
  },
  'enterprise-content-management-ecm-software': {
    defaultMessage: 'Enterprise Content Management (ECM) Software',
    description: 'product category label',
  },
  'enterprise-monitoring-software': {
    defaultMessage: 'Enterprise Monitoring Software',
    description: 'product category label',
  },
  'enterprise-resource-planning-erp-software': {
    defaultMessage: 'Enterprise Resource Planning (ERP) Software',
    description: 'product category label',
  },
  'event-management-software': {
    defaultMessage: 'Event Management Software',
    description: 'product category label',
  },
  'farm-management-software': {
    defaultMessage: 'Farm Management Software',
    description: 'product category label',
  },
  'fashion-design-software': {
    defaultMessage: 'Fashion Design Software',
    description: 'product category label',
  },
  'fax-server-software': {
    defaultMessage: 'Fax Server Software',
    description: 'product category label',
  },
  'field-service-management-fsm-software': {
    defaultMessage: 'Field Service Management (FSM) Software',
    description: 'product category label',
  },
  'financial-analytics-software': {
    defaultMessage: 'Financial Analytics Software',
    description: 'product category label',
  },
  'financial-risk-management-software': {
    defaultMessage: 'Financial Risk Management Software',
    description: 'product category label',
  },
  'fitness-club-management-software': {
    defaultMessage: 'Fitness Club Management Software',
    description: 'product category label',
  },
  'fleet-management-software': {
    defaultMessage: 'Fleet Management Software',
    description: 'product category label',
  },
  'food-delivery-software': {
    defaultMessage: 'Food Delivery Software',
    description: 'product category label',
  },
  'food-traceability-software': {
    defaultMessage: 'Food Traceability Software',
    description: 'product category label',
  },
  'forestry-software': {
    defaultMessage: 'Forestry Software',
    description: 'product category label',
  },
  'fraud-protection-software': {
    defaultMessage: 'Fraud Protection Software',
    description: 'product category label',
  },
  'freight-management-software': {
    defaultMessage: 'Freight Management Software',
    description: 'product category label',
  },
  'funeral-home-software': {
    defaultMessage: 'Funeral Home Software',
    description: 'product category label',
  },
  'gaming-pc': {
    defaultMessage: 'Gaming - PC',
    description: 'product category label',
  },
  'gaming-mobile': {
    defaultMessage: 'Gaming - Mobile',
    description: 'product category label',
  },
  'gaming-console': {
    defaultMessage: 'Gaming - Console',
    description: 'product category label',
  },
  'gaming-vr': {
    defaultMessage: 'Gaming - VR',
    description: 'product category label',
  },
  'gaming-web3blockchain': {
    defaultMessage: 'Gaming - Web3/Blockchain',
    description: 'product category label',
  },
  'gaming-technologyservice': {
    defaultMessage: 'Gaming - Technology/Service',
    description: 'product category label',
  },
  'gaming-gambling': {
    defaultMessage: 'Gaming - Gambling',
    description: 'product category label',
  },
  'gdpr-compliance-software': {
    defaultMessage: 'GDPR Compliance Software',
    description: 'product category label',
  },
  'gps-navigation-software': {
    defaultMessage: 'GPS Navigation Software',
    description: 'product category label',
  },
  'gps-trackers': {
    defaultMessage: 'GPS Trackers',
    description: 'product category label',
  },
  'geographic-information-system-gis-software': {
    defaultMessage: 'Geographic Information System (GIS) Software',
    description: 'product category label',
  },
  'geology-software': {
    defaultMessage: 'Geology Software',
    description: 'product category label',
  },
  'global-trade-management-software': {
    defaultMessage: 'Global Trade Management Software',
    description: 'product category label',
  },
  'governance-risk-management-and-compliance-grc-software': {
    defaultMessage: 'Governance, Risk Management, and Compliance (GRC) Software',
    description: 'product category label',
  },
  'hvac-software': {
    defaultMessage: 'HVAC Software',
    description: 'product category label',
  },
  'healthcare-analytics-software': {
    defaultMessage: 'Healthcare Analytics Software',
    description: 'product category label',
  },
  'healthcare-crm-software': {
    defaultMessage: 'Healthcare CRM Software',
    description: 'product category label',
  },
  'healthcare-lms-software': {
    defaultMessage: 'Healthcare LMS Software',
    description: 'product category label',
  },
  'help-desk-software': {
    defaultMessage: 'Help Desk Software',
    description: 'product category label',
  },
  'higher-education-student-information-systems': {
    defaultMessage: 'Higher Education Student Information Systems',
    description: 'product category label',
  },
  'home-care-software': {
    defaultMessage: 'Home Care Software',
    description: 'product category label',
  },
  'home-inspection-software': {
    defaultMessage: 'Home Inspection Software',
    description: 'product category label',
  },
  'hotel-management-software': {
    defaultMessage: 'Hotel Management Software',
    description: 'product category label',
  },
  'hotel-reservation-software': {
    defaultMessage: 'Hotel Reservation Software',
    description: 'product category label',
  },
  'human-resources-management-systems-hrms': {
    defaultMessage: 'Human Resources Management Systems (HRMS)',
    description: 'product category label',
  },
  'human-services-software': {
    defaultMessage: 'Human Services Software',
    description: 'product category label',
  },
  'idea-management-software': {
    defaultMessage: 'Idea Management Software',
    description: 'product category label',
  },
  'identity-access-management-iam-software': {
    defaultMessage: 'Identity & Access Management (IAM) Software',
    description: 'product category label',
  },
  'identity-verification-software': {
    defaultMessage: 'Identity Verification Software',
    description: 'product category label',
  },
  'image-recognition-software': {
    defaultMessage: 'Image Recognition Software',
    description: 'product category label',
  },
  'infrastructure-as-a-service-iaas': {
    defaultMessage: 'Infrastructure as a Service (IaaS)',
    description: 'product category label',
  },
  'insurance-agency-management-systems': {
    defaultMessage: 'Insurance Agency Management Systems',
    description: 'product category label',
  },
  'integrated-development-environments-ide': {
    defaultMessage: 'Integrated Development Environments (IDE)',
    description: 'product category label',
  },
  'integrated-workplace-management-systems-iwms': {
    defaultMessage: 'Integrated Workplace Management Systems (IWMS)',
    description: 'product category label',
  },
  'intellectual-property-ip-management-software': {
    defaultMessage: 'Intellectual Property (IP) Management Software',
    description: 'product category label',
  },
  'interactive-voice-response-ivr-software': {
    defaultMessage: 'Interactive Voice Response (IVR) Software',
    description: 'product category label',
  },
  'internet-of-things-iot-software': {
    defaultMessage: 'Internet of Things (IoT) Software',
    description: 'product category label',
  },
  'inventory-management-software': {
    defaultMessage: 'Inventory Management Software',
    description: 'product category label',
  },
  'investment-portfolio-management-software': {
    defaultMessage: 'Investment Portfolio Management Software',
    description: 'product category label',
  },
  'jewellery-store-management-software': {
    defaultMessage: 'Jewellery Store Management Software',
    description: 'product category label',
  },
  'job-boards-software': {
    defaultMessage: 'Job Boards Software',
    description: 'product category label',
  },
  'knowledge-management-software': {
    defaultMessage: 'Knowledge Management Software',
    description: 'product category label',
  },
  'laboratory-information-management-systems-lims': {
    defaultMessage: 'Laboratory Information Management Systems (LIMS)',
    description: 'product category label',
  },
  'land-management-software': {
    defaultMessage: 'Land Management Software',
    description: 'product category label',
  },
  'law-practice-management-software': {
    defaultMessage: 'Law Practice Management Software',
    description: 'product category label',
  },
  'lead-generation-software': {
    defaultMessage: 'Lead Generation Software',
    description: 'product category label',
  },
  'learning-management-systems-lms': {
    defaultMessage: 'Learning Management Systems (LMS)',
    description: 'product category label',
  },
  'lease-accounting-software': {
    defaultMessage: 'Lease Accounting Software',
    description: 'product category label',
  },
  'legal-research-software': {
    defaultMessage: 'Legal Research Software',
    description: 'product category label',
  },
  'library-management-software': {
    defaultMessage: 'Library Management Software',
    description: 'product category label',
  },
  'live-chat-software': {
    defaultMessage: 'Live Chat Software',
    description: 'product category label',
  },
  'load-testing-software': {
    defaultMessage: 'Load Testing Software',
    description: 'product category label',
  },
  'loan-servicing-software': {
    defaultMessage: 'Loan Servicing Software',
    description: 'product category label',
  },
  'location-intelligence-software': {
    defaultMessage: 'Location Intelligence Software',
    description: 'product category label',
  },
  'low-code-development-platforms': {
    defaultMessage: 'Low-Code Development Platforms',
    description: 'product category label',
  },
  'machine-learning-software': {
    defaultMessage: 'Machine Learning Software',
    description: 'product category label',
  },
  'manufacturing-execution-system-mes-software': {
    defaultMessage: 'Manufacturing Execution System (MES) Software',
    description: 'product category label',
  },
  'marina-management-software': {
    defaultMessage: 'Marina Management Software',
    description: 'product category label',
  },
  'marketing-automation-software': {
    defaultMessage: 'Marketing Automation Software',
    description: 'product category label',
  },
  'marketplace-platforms': {
    defaultMessage: 'Marketplace Platforms',
    description: 'product category label',
  },
  'medical-inventory-software': {
    defaultMessage: 'Medical Inventory Software',
    description: 'product category label',
  },
  'medical-practice-management-software': {
    defaultMessage: 'Medical Practice Management Software',
    description: 'product category label',
  },
  'mental-health-software': {
    defaultMessage: 'Mental Health Software',
    description: 'product category label',
  },
  'metal-fabrication-software': {
    defaultMessage: 'Metal Fabrication Software',
    description: 'product category label',
  },
  'mining-software': {
    defaultMessage: 'Mining Software',
    description: 'product category label',
  },
  'multiple-listing-service-mls-software': {
    defaultMessage: 'Multiple Listing Service (MLS) Software',
    description: 'product category label',
  },
  'municipal-software': {
    defaultMessage: 'Municipal Software',
    description: 'product category label',
  },
  'natural-language-processing-nlp-software': {
    defaultMessage: 'Natural Language Processing (NLP) Software',
    description: 'product category label',
  },
  'newsroom-computer-systems': {
    defaultMessage: 'Newsroom Computer Systems',
    description: 'product category label',
  },
  'no-code-development-platforms': {
    defaultMessage: 'No-Code Development Platforms',
    description: 'product category label',
  },
  'note-taking-software': {
    defaultMessage: 'Note-Taking Software',
    description: 'product category label',
  },
  'office-suites-software': {
    defaultMessage: 'Office Suites Software',
    description: 'product category label',
  },
  'oil-gas-software': {
    defaultMessage: 'Oil & Gas Software',
    description: 'product category label',
  },
  'online-community-software': {
    defaultMessage: 'Online Community Software',
    description: 'product category label',
  },
  'online-course-platforms': {
    defaultMessage: 'Online Course Platforms',
    description: 'product category label',
  },
  'online-proctoring-software': {
    defaultMessage: 'Online Proctoring Software',
    description: 'product category label',
  },
  'order-management-software': {
    defaultMessage: 'Order Management Software',
    description: 'product category label',
  },
  'pdf-editor-software': {
    defaultMessage: 'PDF Editor Software',
    description: 'product category label',
  },
  'patient-engagement-software': {
    defaultMessage: 'Patient Engagement Software',
    description: 'product category label',
  },
  'payment-processing-software': {
    defaultMessage: 'Payment Processing Software',
    description: 'product category label',
  },
  'payroll-software': {
    defaultMessage: 'Payroll Software',
    description: 'product category label',
  },
  'personal-trainer-software': {
    defaultMessage: 'Personal Trainer Software',
    description: 'product category label',
  },
  'pharmacy-management-systems': {
    defaultMessage: 'Pharmacy Management Systems',
    description: 'product category label',
  },
  'photo-editing-software': {
    defaultMessage: 'Photo Editing Software',
    description: 'product category label',
  },
  'picture-archiving-communication-system-pacs-software': {
    defaultMessage: 'Picture Archiving & Communication System (PACS) Software',
    description: 'product category label',
  },
  'platform-as-a-service-paas-software': {
    defaultMessage: 'Platform as a Service (PaaS) Software',
    description: 'product category label',
  },
  'pre-employment-testing-software': {
    defaultMessage: 'Pre-Employment Testing Software',
    description: 'product category label',
  },
  'predictive-analytics-software': {
    defaultMessage: 'Predictive Analytics Software',
    description: 'product category label',
  },
  'presentation-software': {
    defaultMessage: 'Presentation Software',
    description: 'product category label',
  },
  'printed-circuit-board-pcb-design-software': {
    defaultMessage: 'Printed Circuit Board (PCB) Design Software',
    description: 'product category label',
  },
  'procure-to-pay-p2p-software': {
    defaultMessage: 'Procure to Pay (P2P) Software',
    description: 'product category label',
  },
  'procurement-software': {
    defaultMessage: 'Procurement Software',
    description: 'product category label',
  },
  'product-data-management-pdm-software': {
    defaultMessage: 'Product Data Management (PDM) Software',
    description: 'product category label',
  },
  'product-information-management-pim-software': {
    defaultMessage: 'Product Information Management (PIM) Software',
    description: 'product category label',
  },
  'product-lifecycle-management-plm-software': {
    defaultMessage: 'Product Lifecycle Management (PLM) Software',
    description: 'product category label',
  },
  'product-management-software': {
    defaultMessage: 'Product Management Software',
    description: 'product category label',
  },
  'production-scheduling-software': {
    defaultMessage: 'Production Scheduling Software',
    description: 'product category label',
  },
  'project-management-software': {
    defaultMessage: 'Project Management Software',
    description: 'product category label',
  },
  'property-management-software': {
    defaultMessage: 'Property Management Software',
    description: 'product category label',
  },
  'public-transportation-software': {
    defaultMessage: 'Public Transportation Software',
    description: 'product category label',
  },
  'punch-list-software': {
    defaultMessage: 'Punch List Software',
    description: 'product category label',
  },
  'quality-management-system-qms-software': {
    defaultMessage: 'Quality Management System (QMS) Software',
    description: 'product category label',
  },
  'real-estate-crm-software': {
    defaultMessage: 'Real Estate CRM Software',
    description: 'product category label',
  },
  'real-estate-marketing-software': {
    defaultMessage: 'Real Estate Marketing Software',
    description: 'product category label',
  },
  'recruiting-software': {
    defaultMessage: 'Recruiting Software',
    description: 'product category label',
  },
  'remote-support-software': {
    defaultMessage: 'Remote Support Software',
    description: 'product category label',
  },
  'reputation-management-software': {
    defaultMessage: 'Reputation Management Software',
    description: 'product category label',
  },
  'restaurant-management-software': {
    defaultMessage: 'Restaurant Management Software',
    description: 'product category label',
  },
  'restaurant-reservation-software': {
    defaultMessage: 'Restaurant Reservation Software',
    description: 'product category label',
  },
  'retail-assortment-management-software': {
    defaultMessage: 'Retail Assortment Management Software',
    description: 'product category label',
  },
  'retail-execution-software': {
    defaultMessage: 'Retail Execution Software',
    description: 'product category label',
  },
  'retail-pos-systems': {
    defaultMessage: 'Retail POS Systems',
    description: 'product category label',
  },
  'robotic-process-automation-rpa-software': {
    defaultMessage: 'Robotic Process Automation (RPA) Software',
    description: 'product category label',
  },
  'route-planning-software': {
    defaultMessage: 'Route Planning Software',
    description: 'product category label',
  },
  'sms-marketing-software': {
    defaultMessage: 'SMS Marketing Software',
    description: 'product category label',
  },
  'sales-enablement-software': {
    defaultMessage: 'Sales Enablement Software',
    description: 'product category label',
  },
  'salon-software': {
    defaultMessage: 'Salon Software',
    description: 'product category label',
  },
  'school-management-software': {
    defaultMessage: 'School Management Software',
    description: 'product category label',
  },
  'search-engine-optimization-seo-software': {
    defaultMessage: 'Search Engine Optimization (SEO) Software',
    description: 'product category label',
  },
  'security-awareness-training-software': {
    defaultMessage: 'Security Awareness Training Software',
    description: 'product category label',
  },
  'self-service-kiosks': {
    defaultMessage: 'Self Service Kiosks',
    description: 'product category label',
  },
  'server-monitoring-software': {
    defaultMessage: 'Server Monitoring Software',
    description: 'product category label',
  },
  'service-desk-software': {
    defaultMessage: 'Service Desk Software',
    description: 'product category label',
  },
  'shipping-software': {
    defaultMessage: 'Shipping Software',
    description: 'product category label',
  },
  'simulation-software': {
    defaultMessage: 'Simulation Software',
    description: 'product category label',
  },
  'social-media-management-software': {
    defaultMessage: 'Social Media Management Software',
    description: 'product category label',
  },
  'social-networking-software': {
    defaultMessage: 'Social Networking Software',
    description: 'product category label',
  },
  'software-development-kits-sdk': {
    defaultMessage: 'Software Development Kits (SDK)',
    description: 'product category label',
  },
  'speech-analytics-software': {
    defaultMessage: 'Speech Analytics Software',
    description: 'product category label',
  },
  'speech-recognition-software': {
    defaultMessage: 'Speech Recognition Software',
    description: 'product category label',
  },
  'spreadsheet-software': {
    defaultMessage: 'Spreadsheet Software',
    description: 'product category label',
  },
  'statistical-analysis-software': {
    defaultMessage: 'Statistical Analysis Software',
    description: 'product category label',
  },
  'strategic-planning-software': {
    defaultMessage: 'Strategic Planning Software',
    description: 'product category label',
  },
  'supply-chain-management-software': {
    defaultMessage: 'Supply Chain Management Software',
    description: 'product category label',
  },
  'survey-software': {
    defaultMessage: 'Survey Software',
    description: 'product category label',
  },
  'sustainability-software': {
    defaultMessage: 'Sustainability Software',
    description: 'product category label',
  },
  'taxi-dispatch-software': {
    defaultMessage: 'Taxi Dispatch Software',
    description: 'product category label',
  },
  'telemedicine-software': {
    defaultMessage: 'Telemedicine Software',
    description: 'product category label',
  },
  'test-management-tools': {
    defaultMessage: 'Test Management Tools',
    description: 'product category label',
  },
  'text-mining-software': {
    defaultMessage: 'Text Mining Software',
    description: 'product category label',
  },
  'threat-intelligence-platforms': {
    defaultMessage: 'Threat Intelligence Platforms',
    description: 'product category label',
  },
  'time-tracking-software': {
    defaultMessage: 'Time Tracking Software',
    description: 'product category label',
  },
  'towing-software': {
    defaultMessage: 'Towing Software',
    description: 'product category label',
  },
  'transportation-management-systems-tms': {
    defaultMessage: 'Transportation Management Systems (TMS)',
    description: 'product category label',
  },
  'travel-management-software': {
    defaultMessage: 'Travel Management Software',
    description: 'product category label',
  },
  'trucking-software': {
    defaultMessage: 'Trucking Software',
    description: 'product category label',
  },
  'tutoring-software': {
    defaultMessage: 'Tutoring Software',
    description: 'product category label',
  },
  'unified-communications-as-a-service-ucaas-platforms': {
    defaultMessage: 'Unified Communications as a Service (UCaaS) Platforms',
    description: 'product category label',
  },
  'video-conferencing-software': {
    defaultMessage: 'Video Conferencing Software',
    description: 'product category label',
  },
  'vineyard-management-systems': {
    defaultMessage: 'Vineyard Management Systems',
    description: 'product category label',
  },
  'virtual-classroom-software': {
    defaultMessage: 'Virtual Classroom Software',
    description: 'product category label',
  },
  'virtual-event-platforms': {
    defaultMessage: 'Virtual Event Platforms',
    description: 'product category label',
  },
  'virtual-reality-software': {
    defaultMessage: 'Virtual Reality Software',
    description: 'product category label',
  },
  'visitor-management-systems': {
    defaultMessage: 'Visitor Management Systems',
    description: 'product category label',
  },
  'voip-software': {
    defaultMessage: 'VoIP Software',
    description: 'product category label',
  },
  'voting-software': {
    defaultMessage: 'Voting Software',
    description: 'product category label',
  },
  'warehouse-management-systems-wms': {
    defaultMessage: 'Warehouse Management Systems (WMS)',
    description: 'product category label',
  },
  'warranty-management-software': {
    defaultMessage: 'Warranty Management Software',
    description: 'product category label',
  },
  'waste-management-software': {
    defaultMessage: 'Waste Management Software',
    description: 'product category label',
  },
  'web-content-management-wcm-systems': {
    defaultMessage: 'Web Content Management (WCM) Systems',
    description: 'product category label',
  },
  'web-hosting': {
    defaultMessage: 'Web Hosting',
    description: 'product category label',
  },
  'website-builder-software': {
    defaultMessage: 'Website Builder Software',
    description: 'product category label',
  },
  'website-monitoring-software': {
    defaultMessage: 'Website Monitoring Software',
    description: 'product category label',
  },
  'workflow-management-software': {
    defaultMessage: 'Workflow Management Software',
    description: 'product category label',
  },
  'workforce-management-software': {
    defaultMessage: 'Workforce Management Software',
    description: 'product category label',
  },
  'yard-management-software': {
    defaultMessage: 'Yard Management Software',
    description: 'product category label',
  },
});
